import styled from 'styled-components';

import { Form } from 'components/ui/Form';
import { LinkButton } from 'components/ui/Button';
import { ButtonContent } from 'components/ui/Button/Button.styles';

import { colours } from 'themes/default';

export const StyledLinkButton = styled(LinkButton)`
  padding: 0;
  width: 200px;

  ${ButtonContent} {
    justify-content: flex-start;
    font-size: 14px;
    font-weight: 500;

    > :first-child {
      margin-right: 10px;
    }
  }
`;

export const StyledForm = styled(Form)`
  padding: 16px;
  background-color: white;
  width: inherit;
  box-shadow: 0px 0px 30px ${colours.Greyscale.MistGrey};
`;

export const StyledTextArea = styled.textarea`
  display: block;
  box-sizing: border-box;
  border-radius: 5px;
  width: 100%;
  height: 200px;
  resize: none;
`;

export const DetailsContainer = styled.div`
  margin: 10px 0 0 0;
  width: inherit;
  background-color: white;
  box-shadow: 0px 0px 30px ${colours.Greyscale.MistGrey};
`;
